import { Component } from '@angular/core';

@Component({
  selector: 'app-two-split-image-bullet-points-section',
  standalone: true,
  imports: [],
  templateUrl: './two-split-image-bullet-points-section.component.html',
  styleUrl: './two-split-image-bullet-points-section.component.scss'
})
export class TwoSplitImageBulletPointsSectionComponent {

}
